import { styled, Tooltip } from '@mui/material'
import { useTranslation } from 'next-i18next'
import MapDownloadIcon from 'assets/icons/nucleo/18px_map-download.svg'
import { minWidthIcon } from 'components/Layout/Header/Header.style'
import { StyledButton } from 'components/common/Button/Button.style'

export const GpxButton = styled(StyledButton)`
  position: absolute;
  bottom: 10px;
  right: 10px;
  z-index: 1000;
`

interface GpxDownloadButtonProps {
  gpxUrl: string
}

export const GpxDownloadButton = ({ gpxUrl }: GpxDownloadButtonProps) => {
  const { t } = useTranslation('event')

  const handleDownload = () => {
    const link = document.createElement('a')
    link.setAttribute('href', gpxUrl)
    link.setAttribute('download', 'parcours.gpx')
    document.body.appendChild(link)
    link.click()
    document.body.removeChild(link)
  }

  return (
    <Tooltip title={t('downloadGpx')} placement="left">
      <GpxButton onClick={handleDownload} $hasIcon>
        <MapDownloadIcon css={minWidthIcon} />
      </GpxButton>
    </Tooltip>
  )
}
